import { Injectable } from '@angular/core';
import { CustomOccProduct, CustomProduct } from '@product/const';
import { Converter } from '@spartacus/core';

@Injectable({ providedIn: 'root' })
export class ProductDocumentsNormalizer implements Converter<Partial<CustomOccProduct>, Partial<CustomProduct>> {
  convert(source: Partial<CustomOccProduct>, target?: CustomProduct): Partial<CustomProduct> {
    if (target === undefined) {
      target = { ...(source as any) };
    }

    // фильтруем сертификаты у которых не заполнены обязательные поля
    if (source.certificates) {
      target.certificates = source.certificates.filter(({ mime, url }) => Boolean(mime && url));
    }

    return target;
  }
}
